import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  ComponentFactoryResolver,
  ViewChild,
  ViewContainerRef,
  ComponentFactory,
  ComponentRef,
  AfterViewInit,
  OnDestroy,
  HostListener
} from '@angular/core';

import { GameVideoComponent } from '../game-video/game-video.component';
import { GameMemoryComponent } from '../game-memory/game-memory.component';
import { GameQuestionsComponent } from '../game-questions/game-questions.component';
import { Game, Level, GameVideo } from '../../_models/model';
import { ActivatedRoute, Router } from '@angular/router';
import { GameGoodBadComponent } from '../game-good-bad/game-good-bad.component';
import { GameHelpingThoughtsComponent } from '../game-helping-thoughts/game-helping-thoughts.component';
import { GameStressheadComponent } from '../game-stresshead/game-stresshead.component';
import { Subscription } from 'rxjs';
import { AudioPlayerService } from '../../services/audio-player.service';
import { SafeHtml } from '@angular/platform-browser';
import { ApplicationTextType } from '../../languages/IApplicationText';
import { GameType } from '../../_models/game';
import { GameService } from '../../services/game.service';
import { GameClickerComponent } from '../game-clicker/game-clicker.component';
import { environment } from '../../../environments/environment';

export interface IGameComponent<T = any> {
  setGame(game: T): void;
  closeEvent: EventEmitter<boolean>;
}

@Component({
  selector: 'app-game',
  templateUrl: './game.component.html',
  styleUrls: ['./game.component.less']
})
export class GameComponent implements OnInit, AfterViewInit, OnDestroy {
  @HostListener('window:keydown.z', ['$event'])
  debugGameComplete(keycode: KeyboardEvent) {
    if (!environment.allowSkip) {
      return;
    }
    if (!this.activeGame) {
      return;
    }
    this.gameService.setLevelProgress(this.activeGame.levelElement.uuid, '', true);
    this.gameFinished();
  }
  @HostListener('window:keydown.y', ['$event'])
  debugLevelComplete(keycode: KeyboardEvent) {
    if (!environment.allowSkip) {
      return;
    }
    this.showLevelComplete();
  }
  @ViewChild('gameTemplateContainer', { read: ViewContainerRef }) gameTemplateContainer!: ViewContainerRef;
  @ViewChild('fullScreenGameTemplateContainer', { read: ViewContainerRef }) fullScreenGameTemplateContainer!: ViewContainerRef;

  @Output() onClose = new EventEmitter<any>();
  @Output() hideBackButton = new EventEmitter<any>();

  private goToDashboard = false;
  private containerCloseSubscription: Subscription | undefined;
  private componentReference: ComponentRef<IGameComponent> | null = null;
  private componentFullScreenReference: ComponentRef<IGameComponent> | null = null;

  public activeLevelNumber: number | null = null;
  public activeGame: Game | null = null;
  public gameType: GameType | null = null;
  public gameTitle?: string;
  public gameIcon?: string;
  public showGameEndScreen = false;
  public showLevelEndScreen = false;
  public showDiplomaEndScreen = false;
  public activeType: GameType | null = null;
  public gameFinishedText?: SafeHtml;
  public gameFinishedTextAanvulling?: SafeHtml;
  public showDiploma = false;
  public caption: string = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private gameService: GameService,
    private resolver: ComponentFactoryResolver,
    public audio: AudioPlayerService,
  ) {

  }

  ngOnInit() {
    // console.log('init game');
    //
    const levelStepNr = this.route.parent?.snapshot.params['id'];
    const gameConfig: Game = this.route.snapshot.data['game'];


    if (!gameConfig) {
      throw Error('no gameconfig found for game with id: ' + levelStepNr);
    }
    const level  = this.gameService.getLevel(+levelStepNr)

    this.activeLevelNumber = level.order;
    gameConfig.levelNumber = this.activeLevelNumber;

    this.activeGame = gameConfig;
    this.activeType = this.activeGame.type || null;
    this.caption = this.getGameCaption();
  }

  private getGameCaption() {
    switch (this.activeType) {
      case 'GameMultipleChoice':  return this.audio.text.games.title_GameMultipleChoice;
      case 'GameMemory':  return this.audio.text.games.chooseEmotion;
      case 'GameGoodBad': return  this.audio.text.games.goodbad;
      case 'GameHelpendeGedachten': return this.audio.text.games.helpingToughts;
      case 'GameStresshoofd': return this.audio.text.games.stresshead;
      case 'GameVideo': return this.audio.text.games.title_GameVideo;
      case 'GameClicker': return this.audio.text.games.title_GameClicker;
      default:
        throw Error('no caption set for ' + this.activeType);
    }
  }

  public ngOnDestroy() {

    if (this.componentReference) {
      this.componentReference.destroy();
      this.componentReference = null;
    }

    if (this.componentFullScreenReference) {
      this.componentFullScreenReference.destroy();
      this.componentFullScreenReference = null;
    }

    if (this.containerCloseSubscription) {
      this.containerCloseSubscription.unsubscribe();
    }
  }

  debugKeyPress(e: KeyboardEvent): void {
    if (!environment.allowSkip) {
      return;
    }
    if (e.key === 'z') {
      alert('z2');
      this.gameFinished();
    }
  }

  ngAfterViewInit() {

    if (this.gameTemplateContainer) {
      this.gameTemplateContainer.clear();
    }
    if (this.fullScreenGameTemplateContainer) {
      this.fullScreenGameTemplateContainer.clear();
    }
    this.activeType = this.activeGame?.type || null;
    if (!this.activeType || !this.activeGame) {
      throw Error('no active type set');
    }



    switch (this.activeGame.type) {
        case 'GameVideo':
        case 'GameClicker':
          this.initFullScreenGame();
          break;
        default:
          this.initOtherPopupGame();
    }
  }

  private initFullScreenGame() {
    switch (this.activeType) {
        case 'GameVideo':
          this.componentFullScreenReference = this.fullScreenGameTemplateContainer.createComponent(GameVideoComponent);
          break;
        case 'GameClicker':
          this.componentFullScreenReference = this.fullScreenGameTemplateContainer.createComponent(GameClickerComponent);
          break;
        default:
          throw Error('no full screen game for ' + this.activeType)
    }

    this.componentFullScreenReference.instance.setGame(this.activeGame);
    this.componentFullScreenReference.changeDetectorRef.detectChanges();
    this.containerCloseSubscription = this.componentFullScreenReference.instance.closeEvent
       .subscribe(shouldShowFinished => {
        if (shouldShowFinished) {
          // Show end screen if video is ended.
          this.gameFinished();
        } else {
          // Don't show end screen if cross in video player is pressed!
          this.closeEndScreen(false);
        }
    });
  }

  private initClicker() {

  }


  private initOtherPopupGame() {
    // let factory: ComponentFactory<any>;

    switch (this.activeType) {
      case 'GameMultipleChoice':
        this.componentReference = this.gameTemplateContainer.createComponent(GameQuestionsComponent);
        break;
      case 'GameMemory':
        this.componentReference = this.gameTemplateContainer.createComponent(GameMemoryComponent);
        break;
      case 'GameGoodBad':
        this.componentReference = this.gameTemplateContainer.createComponent(GameGoodBadComponent);
        break;
      case 'GameHelpendeGedachten':
        this.componentReference = this.gameTemplateContainer.createComponent(GameHelpingThoughtsComponent);
        break;
      case 'GameStresshoofd':
        this.componentReference = this.gameTemplateContainer.createComponent(GameStressheadComponent);
        break;
      default:
          throw Error('factory not used for this game type');
    }

    this.componentReference.instance.setGame(this.activeGame);
    this.containerCloseSubscription = this.componentReference.instance.closeEvent.subscribe((response: boolean) => {
      if (!response) {
        this.gameFinished();
      }
    });
    // this.componentReference.instance.game = this.activeGame;

    // Do it here instead of in the GameStressheadComponent at setGame in order to get the correct lifecycle hook order.
    // DON'T do this with other components, as we rely on this broken functionality in some cases.
    if (this.activeType === 'GameStresshoofd' || this.activeType === 'GameMemory') {
      this.componentReference.changeDetectorRef.detectChanges();

    }

  }


  gameFinished() {
    // console.log('gameFinished');
    if (!this.activeGame) {
      throw Error('no active game');
    }
    if (this.activeLevelNumber === null) {
      throw Error('no active level');
    }
    this.gameTitle = (this.audio.text.games as any)['title_' + this.activeGame?.type] || '';
    const steps: number[] = this.gameService.getLevel(this.activeLevelNumber).levelElements.map(l => {return l.step});
    const maxStep = Math.max(...steps);

    if (this.activeGame.levelElement.step === maxStep) {
      if (this.activeLevelNumber > 0) {
        this.showLevelComplete();
      } else {
        this.router.navigate(['/dashboard']);
      }
    } else {
      this.showGameComplete();
    }

    this.activeType = null;
  }

  private showGameComplete() {
    this.showGameEndScreen = true;
    // Video has no end screen
    if (this.activeType === 'GameVideo') {
      this.closeEndScreen(false);
      return;
    }

    // Init game complete images
    this.gameIcon = '/img/popup/won-game-types/' + this.activeType + '.svg';
    this.gameFinishedText = this.audio.getHTML('game_afgerond');

    this.audio.playSoundGameFinished();

    // Show message after 3 seconds
    setTimeout(() => {
      this.audio.play('game_afgerond');
    }, 3 * 1000);

  }

  private showLevelComplete() {
    this.showLevelEndScreen = true;
    this.caption = '';
    // Should not happen
    if (this.activeLevelNumber === null) {
      throw Error('no active level loaded');
    }

    this.goToDashboard = true;
    this.audio.playSoundLevelFinished();

    // If all levels completed
    // if (this.activeLevelNumber === 8) {
    //   this.showEndLevelComplete()
    //   return;
    // }

    // Show end level
    // this.gameIcon = `/img/popup/won-level-types/Voorwerp_level_${this.activeLevelNumber + 1}.svg`;
    // this.gameFinishedText = this.audio.getHTML('level' + this.activeLevelNumber + '_afgerond' as ApplicationTextType);
    // this.gameFinishedTextAanvulling = this.audio.getHTML('level_afgerond_' + this.activeLevelNumber as ApplicationTextType)
    // Play sound after 6 seconds?
    setTimeout(() => {
      this.audio.play('level' + this.activeLevelNumber + '_afgerond' as ApplicationTextType);
    }, 6 * 1000);

  }
  private showEndLevelComplete() {
    // hide next button at diploma screen
    this.hideBackButton.emit();
    this.showDiploma = true;
    this.showDiplomaEndScreen = true;
    setTimeout(() => {
      this.audio.play(`diploma`);
    }, 6 * 1000);
  }

  closeEndScreen(goToDashboard: boolean = false) {
    if (!this.goToDashboard) {
      this.showGameEndScreen = false;
      this.showLevelEndScreen = false;
      this.showDiplomaEndScreen = false;
      this.router.navigate(['.', { outlets: { game: null } }], { relativeTo: this.route.parent });
      this.close();
    } else {
      // Go to dashboard if finished last level
      this.router.navigate(['/dashboard']);
    }
  }
  closeLevelEndScreen(goToDashboard: boolean = false) {
    // console.log(this.activeLevelNumber, this.showDiplomaEndScreen);
    if (!this.showDiplomaEndScreen && this.activeLevelNumber ===8) {
      this.showEndLevelComplete();
      return;
    }
    if (!this.goToDashboard) {
      this.showGameEndScreen = false;
      this.showLevelEndScreen = false;
      this.showDiplomaEndScreen = false;
      this.router.navigate(['.', { outlets: { game: null } }], { relativeTo: this.route.parent });
      this.close();
    } else {
      // Go to dashboard if finished last level
      this.router.navigate(['/dashboard']);
    }
  }



  close() {
    this.audio.cancelAll();
    this.activeGame = null;
    this.gameType = null;
    this.onClose.emit();
  }


}
